import {
  closestCenter,
  rectIntersection,
} from '@dnd-kit/core'

export const collisionDetection = (...args) => rectIntersection(...args) || closestCenter(...args)
